import styled from 'styled-components'

const TileContainer = styled.div`
    display: flex;
    flex-direction: row;
    border-bottom: 2px solid #dddee1;
    padding: 10px 10% 10px 10%;
    min-width: 940px;
    font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;

    span {
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;

        color: #606a80;
        padding-right: 8px;
        border-right: 2px solid #dddee1;
    }

    label {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        padding-left: 10px;

        color: #606a80;
    }
`

const MainContainer = styled.div`
    font-family: arial, sans-serif;
    height: 100%;
    overflow: hidden;
    position: relative;
    background-color: transparent;
`
const HeaderContainer = styled.div`
    background-color: #eeeeee;
    width: 100%;
`
export { TileContainer, MainContainer, HeaderContainer }
